<template>
  <div class="bodyBox">
    <div class="contControll">
      <div class="them">1. 基本信息(必填)</div>
      <div class="cont">
        <div class="item">
          <div class="text">企业名称</div>
          <div class="detail">
            {{ detailShow.name }}
          </div>
        </div>
        <div class="item">
          <div class="text">企业社会信用代码证号</div>
          <div class="detail">
            {{ detailShow.code }}
          </div>
        </div>
        <div class="item">
          <div class="text">企业地址-省/市/区县</div>
          <div class="detail" v-if="detailShow.province">
            {{ detailShow.province }}{{ detailShow.city
            }}{{ detailShow.county }}
          </div>
          <div class="detail" v-else>暂无</div>
        </div>
        <div class="item">
          <div class="text">企业详细地址</div>
          <div class="detail">{{ detailShow.address }}</div>
        </div>
        <div class="item">
          <div class="text">成立时间</div>
          <div class="detail">{{ detailShow.com_create_time }}</div>
        </div>
        <div class="item">
          <div class="text">经济类型</div>
          <div class="detail">{{ detailShow.eco_type }}</div>
        </div>
        <div class="item">
          <div class="text">注册资金（万元）</div>
          <div class="detail">{{ detailShow.capital }}</div>
        </div>
        <div
          class="item"
          v-if="detailShow.member_type == 2 || detailShow.member_type == 4"
        >
          <div class="text">在滇办公地址-省/市/区县</div>
          <div class="detail" v-if="detailShow.y_province">
            {{ detailShow.y_province }}{{ detailShow.y_city
            }}{{ detailShow.y_county }}
          </div>
          <div class="detail" v-else>暂无</div>
        </div>
        <div
          class="item"
          v-if="detailShow.member_type == 2 || detailShow.member_type == 4"
        >
          <div class="text">在滇办公详细地址</div>
          <div class="detail">
            {{ detailShow.y_address ? detailShow.y_address : "暂无" }}
          </div>
        </div>
        <div
          class="item"
          v-if="detailShow.member_type == 2 || detailShow.member_type == 4"
        >
          <div class="text">在滇办公电话</div>
          <div class="detail">
            {{ detailShow.y_phone ? detailShow.y_phone : "暂无" }}
          </div>
        </div>
        <!--        老用户统一不要了-->
        <!--        <div class="item">-->
        <!--          <div class="text">原造价资质等级</div>-->
        <!--          <div v-if="detailShow.s_level == 1" class="detail">甲级</div>-->
        <!--          <div v-if="detailShow.s_level == 2" class="detail">乙级</div>-->
        <!--          <div v-if="detailShow.s_level == 3" class="detail">丙级</div>-->
        <!--        </div>-->
        <!--        <div class="item">-->
        <!--          <div class="text">原造价资质证书编号</div>-->
        <!--          <div class="detail">{{ detailShow.s_code }}</div>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="contControll">
      <div class="them">2. 负责人信息(必填)</div>
      <div class="cont">
        <div class="item">
          <div class="text">法定代表人姓名</div>
          <div class="detail">
            {{ detailShow.legal_name ? detailShow.legal_name : "暂无" }}
          </div>
        </div>
        <div class="item">
          <div class="text">法定代表人联系电话</div>
          <div class="detail">
            {{ detailShow.legal_tel ? detailShow.legal_tel : "暂无" }}
          </div>
        </div>
        <div class="item">
          <div class="text">法定代表人职称</div>
          <div class="detail">
            {{ detailShow.legal_title ? detailShow.legal_title : "暂无" }}
          </div>
        </div>
        <div class="item">
          <div class="text">技术负责人姓名</div>
          <div class="detail">
            {{ detailShow.technical_name ? detailShow.technical_name : "暂无" }}
          </div>
        </div>
        <div class="item">
          <div class="text">技术负责人联系电话</div>
          <div class="detail">
            {{ detailShow.technical_tel ? detailShow.technical_tel : "暂无" }}
          </div>
        </div>
        <div class="item">
          <div class="text">技术负责人职称</div>
          <div class="detail">
            {{
              detailShow.technical_title ? detailShow.technical_title : "暂无"
            }}
          </div>
        </div>
        <div class="item">
          <div class="text">技术负责人一级注册造价工程师证书编号</div>
          <div class="detail">
            {{ detailShow.technical_code ? detailShow.technical_code : "暂无" }}
          </div>
        </div>
        <div class="item">
          <div class="text">企业联系人姓名</div>
          <div class="detail">
            {{ detailShow.contact_name ? detailShow.contact_name : "暂无" }}
          </div>
        </div>
        <div class="item">
          <div class="text">企业联系人电话（传真）</div>
          <div class="detail">
            {{ detailShow.contact_tel ? detailShow.contact_tel : "暂无" }}
          </div>
        </div>
        <div class="item">
          <div class="text">电子邮箱</div>
          <div class="detail">
            {{ detailShow.contact_email ? detailShow.contact_email : "暂无" }}
          </div>
        </div>
      </div>
    </div>
    <div class="contControll">
      <div class="them">3. 资质信息(必填)</div>
      <div class="cont">
        <div class="item">
          <div class="text">营业执照</div>
          <a :href="detailShow.license_image" target="_blank" class="check"
            >查看文件</a
          >
        </div>
        <div class="item">
          <div class="text">上传企业承诺书</div>
          <a :href="detailShow.promise_image" target="_blank" class="check"
            >查看文件</a
          >
        </div>
        <div class="item">
          <div class="text">法定代表人身份证(正面)</div>
          <a
            :href="detailShow.legal_idcard_f_image"
            target="_blank"
            class="check"
            >查看文件</a
          >
        </div>
        <div class="item">
          <div class="text">法定代表人身份证(反面)</div>
          <a
            :href="detailShow.legal_idcard_b_image"
            target="_blank"
            class="check"
            >查看文件</a
          >
        </div>
        <div class="item">
          <div class="text">技术负责人身份证(正面)</div>
          <a
            :href="detailShow.technical_idcard_f_image"
            target="_blank"
            class="check"
            >查看文件</a
          >
        </div>
        <div class="item">
          <div class="text">技术负责人身份证(反面)</div>
          <a
            :href="detailShow.technical_idcard_b_image"
            target="_blank"
            class="check"
            >查看文件</a
          >
        </div>
        <div class="item">
          <div class="text">企业联系人身份证(正面)</div>
          <a
            :href="detailShow.contact_idcard_f_image"
            target="_blank"
            class="check"
            >查看文件</a
          >
        </div>
        <div class="item">
          <div class="text">企业联系人身份证(反面)</div>
          <a
            :href="detailShow.contact_idcard_b_image"
            target="_blank"
            class="check"
            >查看文件</a
          >
        </div>
        <div class="item" v-if="detailShow.legal_title != '无'">
          <div class="text">法定代表人职称证</div>
          <a :href="detailShow.legal_title_image" target="_blank" class="check"
            >查看文件</a
          >
        </div>
        <div class="item">
          <div class="text">技术负责人职称证</div>
          <a
            :href="detailShow.technical_title_image"
            target="_blank"
            class="check"
            >查看文件</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { enterprise } from "@/api/company.js";

export default {
  name: "CompanyDetail",
  props: {
    detail: {
      type: Number,
      // default: {},
      default: 0,
    },
  },
  data() {
    return {
      detailShow: {}, //企业基本信息
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.detailShow = await enterprise({ record_id: this.detail });
    },
  },
};
</script>

<style lang="less" scoped>
.bodyBox {
  .contControll {
    display: flex;
    align-items: flex-start;
    margin-top: 50px;

    .them {
      min-width: 190px;
      font-size: 12px;
      font-weight: 700;
      color: #333333;
    }

    .cont {
      flex: 1;

      .item {
        display: flex;
        align-items: center;
        margin-top: 16px;

        &:first-child {
          margin-top: unset;
        }

        .text {
          font-size: 12px;
          color: #999999;
          width: 190px;
        }

        .detail {
          font-size: 12px;
          color: #333333;
        }

        .check {
          font-size: 12px;
          color: #4379f6;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
